export const userState = {
  loading: false,
  user: null,
  error: false,
};
